import styled from 'styled-components';

export const StyledTopMenu = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  .top-menu {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    padding: 10px 16px;
    position: relative;

    &__logo-container {
      display: flex;
      align-items: center;

      img {
        width: 200px;
        cursor: pointer;
      }

      svg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
      }
    }

    &__menu-container {
      display: flex;
      align-items: center;
      flex-shrink: 0;

      &__menu-button {
        transform: rotate(0);
        transition: all ease 0.4s;
        cursor: pointer;

        &:hover {
          transform: scale(1.1) translateZ(0);
        }
      }
    }
  }

  @media (max-width: 600px) {
    .top-menu {
      flex-wrap: wrap;
      gap: 16px;
      padding: 10px 16px;
      justify-content: center;

      &__menu-container {
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
      }
    }
  }
`;
